<template>
  <main class="doctors-register-content pt-2">
    <div
      :class="{ 'b-container': !isMobile }"
    >
      <h1
        class="text--text mb-sm-6 mb-4"
        :class="isMobile ? 'text-h6 px-2' : 'text-h5'"
      >
        {{ t('Регистрация клиники', options) }}
      </h1>

      <div
        class="d-flex flex-column gr-md-16 gr-sm-12 gr-8 doctors-register-content__content"
        :class="{ 'px-2': isMobile }"
      >
        <RegistrationForm
          v-if="context.subject"
          :class="{ 'elevation-1 rounded-sm pa-12': !isMobile }"
          :is-doctor="context.is_doctor"
          :is-lpu="context.is_lpu"
          :date-of-sending-email="context.busy"
          :user-email="context.usr?.user?.email"
          :phone-confirmation-on-doctor-register="context.site_settings.phone_confirmation_on_doctor_register"
          :subject="context.subject"
        />
        <HowToRegister
          v-else
          :class="{ 'elevation-1 rounded-sm pa-12': !isMobile }"
        />

        <v-divider v-if="isMobile" />
        <BenefitsOfRegistration :class="{ 'elevation-1 rounded-sm pa-12': !isMobile }" />

        <v-divider v-if="isMobile" />
        <AdvantagesOfSite />

        <template v-if="!isMobile && context.request.country.is_russia">
          <MediaList />
          <OurPartners />
        </template>
      </div>
    </div>

    <template v-if="isMobile && context.request.country.is_russia">
      <v-divider class="mt-md-16 mt-sm-12 mt-8" />
      <MediaList class="mt-md-16 mt-sm-12 mt-8" />
      <OurPartners class="mt-md-16 mt-sm-12 mt-8" />
    </template>
  </main>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import I18NextVue from 'i18next'
import useContextStore from 'src/store/useContextStore'
import type { ContextStore } from 'src/components/pages/profile/lpus/register/index/types'
import AdvantagesOfSite from 'src/components/pages/profile/lpus/register/index/LpusRegisterContent/components/AdvantagesOfSite.vue'
import BenefitsOfRegistration from 'src/components/pages/profile/lpus/register/index/LpusRegisterContent/components/BenefitsOfRegistration.vue'
import HowToRegister from 'src/components/pages/profile/lpus/register/index/LpusRegisterContent/components/HowToRegister.vue'
import RegistrationForm from 'src/components/pages/profile/lpus/register/index/LpusRegisterContent/components/RegistrationForm/RegistrationForm.vue'
import MediaList from 'src/components/pages/profile/lpus/register/index/LpusRegisterContent/components/MediaAboutUs.vue'
import OurPartners from 'src/components/pages/profile/lpus/register/index/LpusRegisterContent/components/OurPartners.vue'

const { t, language } = I18NextVue
const options = { ns: language }

const { context }: ContextStore = useContextStore()
const isMobile = computed(() => context.flavour === 'mobile')
</script>

<style lang="scss" scoped>
.doctors-register-content {
  &__content > .v-divider {
    min-width: calc(100% + 16px);
    margin: 0 -8px;
  }
}
</style>
